import { BackgroundProps } from "./types";
import { StyledBackground } from "./style";

function Background({
  backgroundImageMobile,
  backgroundImageDesktop,
  width = "100vw",
  height = "100vh",
  position = "fixed",
  children,
}: BackgroundProps) {
  return (
    <StyledBackground
      backgroundImageMobile={backgroundImageMobile}
      backgroundImageDesktop={backgroundImageDesktop}
      width={width}
      height={height}
      position={position}
    >
      {children}
    </StyledBackground>
  );
}

export default Background;
